export default "__VITE_ASSET__0b2a66a8__"